document.addEventListener("DOMContentLoaded", function () {
    const stickyCart = document.querySelector(".product-stikcy-cart.product-container");
    const productMainWrapper = document.querySelector(".product-main-wrapper");

  
    function checkVisibility() {
        const rect = productMainWrapper.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom > 0;

        if (!isVisible) {
            stickyCart.classList.add("active"); // Add class when out of view
        } else {
            stickyCart.classList.remove("active"); // Remove class when in view
        }
    }

    
    window.addEventListener("scroll", checkVisibility);
    window.addEventListener("resize", checkVisibility);

    
    checkVisibility();

   // select box variant click

    let variantSelect = document.querySelector('.product-variant-details');
let addToCartButton = document.querySelector('.add-to-cart');
let soldOutButton = document.querySelector('.sold-out');
let productPrice = document.querySelector('.product-image-wrapper .product-price');

function updateButtonAndPrice() {
    let selectedVariant = variantSelect.options[variantSelect.selectedIndex];
    let VariantQty = parseInt(selectedVariant.getAttribute('data-var-qty'));
    let VariantPrice = selectedVariant.getAttribute('data-var-price');

    // Update price display
    if (productPrice) {
        productPrice.textContent = VariantPrice;
    }

    // Show or hide buttons based on stock quantity
    if (VariantQty > 0) {
        addToCartButton.style.display = 'flex';
        soldOutButton.style.display = 'none';
    } else {
        addToCartButton.style.display = 'none';
        soldOutButton.style.display = 'block';
    }
}

// Listen for variant selection change
variantSelect.addEventListener('change', updateButtonAndPrice);
updateButtonAndPrice(); // Initial check on page load



  // add to cart item
document.body.addEventListener('click', function (event) {
    let addToCartButton = event.target.closest('.product-stikcy-cart.product-container button.add-to-cart');
    if (!addToCartButton) return;

    event.preventDefault();
    let container = addToCartButton.closest('.product-stikcy-cart.product-container.active');
    let selectedOptions = container.querySelectorAll('.main-product-stikcy.product-variant-wrapper option');
    let selectedVariant = [...selectedOptions].find(option => option.selected);

    let isSoldOut = document.querySelector('.product-form__buttons button.product-form__submit.button')?.textContent.trim().includes('Sold out');
    let soldOutButton = container.querySelector('.sold-out');
    let loader = container.querySelector('.sticky-add-to-cart-loader');

    if (selectedVariant) {
        let Variantid = parseInt(selectedVariant.getAttribute('data-var-id'));
        let VariantPrice = selectedVariant.getAttribute('data-var-price');
        let VariantQty = parseInt(selectedVariant.getAttribute('data-var-qty'));

        if (VariantQty <= 0) {
            if (addToCartButton) addToCartButton.style.display = 'none';
            if (soldOutButton) soldOutButton.style.display = 'block';
            return;
        }

        document.querySelector('.product-image-wrapper .product-price').textContent = VariantPrice;

        // Show loader and temporarily hide text
        if (loader) loader.style.display = 'inline-block';
        if (addToCartButton) addToCartButton.style.color = 'transparent';

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ quantity: 1, id: Variantid })
        })
        .then(response => response.json())
        .then(() => {
            fetch('/cart')
                .then(response => response.text())
                .then(data => {
                    document.querySelector('cart-drawer-items').innerHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('cart-drawer-items').innerHTML;
                    document.querySelector('cart-drawer').classList.add('active');
                    refreshCartDrawer();
                    setTimeout(updateCartAndShippingBar, 1000);
                });
        })
        .finally(() => {
            // Hide loader and restore text after request completion
            setTimeout(() => {
                if (loader) loader.style.display = 'none';
                if (addToCartButton) addToCartButton.style.color = ''; // Restore text
            }, 500);
        });
    }
});




function refreshCartDrawer() {
  let cartDrawerItems = document.querySelector("cart-drawer-items");
  const cartDrawer = document.querySelector("cart-drawer");
  const cartDrawerCheckout = document.querySelector(".cart__checkout-button"); // Ensure correct selector

  if (cartDrawer) {
    if (cartDrawer.classList.contains("is-empty")) {
      cartDrawer.classList.remove("is-empty");
    }
      cartDrawerCheckout.removeAttribute("disabled");

    const emptyDrawerElement = cartDrawer.querySelector(".drawer__inner-empty");
    if (emptyDrawerElement) {
      emptyDrawerElement.remove();
    }

    const cartContentsForm = document.querySelector(".cart__contents");
    if (cartContentsForm) {
      cartContentsForm.style.display = "block";
    }
  }

  if (!cartDrawerItems) {
    cartDrawerItems = document.createElement("cart-drawer-items");
    const drawerHeader = document.querySelector(".drawer__header");
    if (drawerHeader) {
      drawerHeader.insertAdjacentElement("afterend", cartDrawerItems);
    }
  }

  const cartItemsComponent = document.querySelector("cart-drawer-items");
  if (cartItemsComponent && typeof cartItemsComponent.onCartUpdate === "function") {
    cartItemsComponent.onCartUpdate();
  }

  if (cartDrawer && typeof cartDrawer.open === "function") {
    cartDrawer.open();
  }
}
});
